import { memo, useEffect, useState, useRef, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Web3 from 'web3'
import { isAddress } from '@ethersproject/address'
import { Input, Card, CardHeader, CardBody, Button, AutoRenewIcon, Text, Flex } from '@pancakeswap/uikit'
import { SelectTag, InputSwapper, Notification, Model } from '@/components'
// import PrivetakeyManger from '../MarKetBot/MarketBotRight/PrivetakeyManger'
import { collection, collectionChange, chainId, privatekeyArray, rpc, token, spenToken, privatekeyArrayChange } from '@/store'
import { Collect } from './style'
import { AppContext } from '@/context'
import { colllectETHHandler, colllectTokenHandler } from '@/utils/getCollect'
import { FooterContent, FooterItem, Item, ItemHeader } from '@/views/MarKetBot/MarketBotLeft/Footer/style'
import { useWalletInfo } from '@/hooks'
import { addressHand } from '@/utils'
import { CopyOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons'
import { chains } from '@/utils/wagmi'
import { safeArray } from '@/views/MarKetBot/MarketBotLeft/Footer'
import copy from '@/utils/copy'
import ModelInput from '@/components/ModelInput'
import { Popconfirm } from 'antd'
import PrivetakeyManger from '@/views/MarKetBot/MarketBotLeft/Footer/PrivetakeyManger'
import { useWalletInfoContext } from '@/context/WalletInfoContext'

function App() {

  const tags = ['BNB', '代币']
  const dispatch = useDispatch()

  const _privaKeyArr = useSelector(privatekeyArray)
  const _collection = useSelector(collection)
  const _chainId = useSelector(chainId)
  const _token = useSelector(token)
  const [tagsIndex, setTagsIndex] = useState(0)
  const [isStart, setIsStart] = useState(false)
  const _rpc = useSelector(rpc)
  const web3 = new Web3(_rpc)
  const { walletAddrArr, walletConfig, getWalletInfo
  } = useWalletInfoContext()
  const _privatekeyArray = useSelector(privatekeyArray)


  useEffect(() => {
    if (_token?.address) {
      const config = { ..._collection }
      config.token = _token?.address
      dispatch(collectionChange(config))
    }
  }, [_token])
  const currentChain = chains.find(c => c.id === _chainId);


  const configChange = (e: { target: { name: string, value: string } }) => {
    const obj = { ..._collection }
    obj[e.target.name] = e.target.value
    dispatch(collectionChange(obj))
  }
  const tagsHandler = (index: number) => {
    setTagsIndex(index)
  }
  const batchTradeRef = useRef(null)

  // 开始归集 原生代币
  const collectionBtn = async () => {
    if (_privaKeyArr.length <= 0) return Notification.Warning(`请先导入需要归集的钱包`)
    if (!isAddress(_collection.to)) return Notification.Warning('填写归集地址')
    if (!isAddress(_collection.token) && tagsIndex === 1) return Notification.Warning('填写代币地址')
    // openModal('请确认归集到钱包：',)
    // alert(`请确认归集到钱包：${_collection.to}`)
    setIsStart(true)
    batchTradeRef.current = new web3.BatchRequest()
    tagsIndex === 0 ? await colllectETHHandler(_privaKeyArr, web3, _collection.to, _chainId, (i, hash) => {
      console.log(`钱包${i + 1} 归集成功，交易哈希: ${hash}`);
    },
      (i, err) => {
        console.log(`钱包${i + 1} 失败：`, err);
      },) : await colllectTokenHandler(_privaKeyArr, web3, _collection, batchTradeRef, _rpc, currentChain)
    setIsStart(false)
    Notification.Success("归集完成")
  }


  const [isShowPriveKeyPage, setIsShowPriveKeyPage] = useState(false)
  const walletBtn = () => {
    setIsShowPriveKeyPage(true)
  }
  const hidePriveKeyPage = () => {
    setIsShowPriveKeyPage(false)
  }
  interface FooterColumn<T = any> {
    header: string;
    data: T[];
    render: (index: number, item: T) => React.ReactNode;
  }
  const { Lang } = useContext(AppContext)
  const len = _privatekeyArray.length
  const footerColumns: FooterColumn[] = [
    {
      header: '序号',
      render: (index) => <div>{index + 1}</div>,
      data: Array.from({ length: len }, (_, i) => i),
    },
    {
      header: `${Lang.WalletAddress} (${len})`,
      render: (index: number, item: string) => (
        <Flex justifyContent="center" alignItems="center">
          <Text>{addressHand(item)}</Text>
          <CopyOutlined onClick={() => copy(item)} />
        </Flex>
      ),
      data: walletAddrArr,
    },
    {
      header: `${chains?.find((c) => c.id === _chainId)?.nativeCurrency?.symbol || ''} ${Lang.balance}`,
      render: (_: number, item: number) => <Text>{item ? Number(item).toFixed(5) : 0}</Text>,
      data: safeArray(walletConfig?.BNBbArr, '0', len),
    },
    // ⭐⭐⭐ 只有 tagsIndex === 1 才显示这一列 ⭐⭐⭐
    ...((tagsIndex === 1 && _token?.address)
      ? [
        {
          header: `${_token?.symbol} ${Lang.balance}`,
          render: (_: number, item: number) => <Text>{Number(item).toFixed(5)}</Text>,
          data: safeArray(walletConfig?.TOKENbArr, '0', len),
        },
      ]
      : []),
    {
      header: Lang.c8,
      render: (index: number) => (
        <Text onClick={() => removeWallet(index)}>
          <DeleteOutlined />
        </Text>
      ),
      data: safeArray(walletConfig.TOKENbArr, '1', _privatekeyArray.length),
    },
  ]
  const removeWallet = (index: number) => {
    const arr = [..._privatekeyArray]
    arr.splice(index, 1)
    dispatch(privatekeyArrayChange(arr))
  }
  interface ModalInfo {
    title: string;
    type: number;
    handleOk: (val: string | { value: string; extraValue: string }) => void;
    msg?: string[]
  }
  const [modalInfo, setModalInfo] = useState<ModalInfo | null>(null);
  const closeModal = () => {
    setModalInfo(null);
  };
  const [isLoading, setIsLoading] = useState(false)

  const freshHandle = async () => {
    setIsLoading(true)
    const res = await getWalletInfo()
    if (!res) Notification.Error("获取余额失败")
    setIsLoading(false)

  }
  return (
    <Collect>
      {isShowPriveKeyPage &&
        <PrivetakeyManger btnCallback={hidePriveKeyPage} />
      }
      <Card>
        <CardHeader>{Lang.Batchcollection}</CardHeader>
        <CardBody>
          <SelectTag tags={tags} callBack={tagsHandler} currentIndex={tagsIndex} />
          {tagsIndex === 1 &&
            <InputSwapper title='代币地址'>
              <Input name='token' value={_collection.token} onChange={configChange} placeholder='代币地址' />
            </InputSwapper>
          }
          <InputSwapper title='归集地址（钱包地址）'>
            <Input name='to' value={_collection.to} onChange={configChange} placeholder='归集地址' />
          </InputSwapper>
          <Button mr='1rem' onClick={walletBtn}>导入钱包</Button>
          <Popconfirm
            title={`请确认归集到钱包：${_collection.to}`}
            // description="Are you sure to delete this task?"
            okText="Yes"
            cancelText="No"
            onConfirm={collectionBtn}
          >
            <Button isLoading={isStart} endIcon={isStart && <AutoRenewIcon spin color="currentColor" />}>归集</Button>
          </Popconfirm>
          <Button ml='1rem' onClick={freshHandle}>{Lang.refresh}{isLoading && <LoadingOutlined />}</Button>

        </CardBody>
      </Card>
      <FooterContent>
        {footerColumns.map((col, colIndex) => (
          <FooterItem key={colIndex}>
            <ItemHeader>
              <Text>{col.header}</Text>
            </ItemHeader>
            {col.data.map((item, index) => (
              <Item key={index}>{col.render(index, item)}</Item>
            ))}
          </FooterItem>
        ))}
      </FooterContent>
      {modalInfo && (
        <ModelInput
          callBack={closeModal}
          handleOks={modalInfo.handleOk}
          title={modalInfo.title}
          type={modalInfo.type}
          msg={modalInfo.msg} />
      )}
    </Collect>
  )
}

export default memo(App)

